import HttpService from '@/services/http/http.service';
import {
    BugTrackerCategoriesViewModel, BugTrackerCategoryViewModel, BugTrackerIssueAddCommentRequest, BugTrackerIssueDetailsViewModel, BugTrackerIssueReactionRequest, BugTrackerIssueRemoveCommentRequest, BugTrackerIssueSummaryViewModel,
    BugTrackerIssuesViewModel, BugTrackerIssueUpdateCommentRequest, BugTrackerIssueViewModel, BugTrackerPriority, BugTrackerStatus, CreateBugTrackerCategoryRequest, CreateBugTrackerIssueRequest, UpdateBugTrackerIssueRequest
} from '@/types/apiServerContract';

const API_PATH = 'bugtracker/';

export class BugTrackerApi {
    public static async GetCategories(): Promise<BugTrackerCategoriesViewModel> {
        return HttpService.Get<BugTrackerCategoriesViewModel>(API_PATH + 'GetCategories');
    }

    public static async GetLatestIssues(): Promise<BugTrackerIssuesViewModel> {
        return HttpService.Get<BugTrackerIssuesViewModel>(API_PATH + 'GetLatestIssues');
    }

    public static async GetIssues(status?: BugTrackerStatus, priority?: BugTrackerPriority): Promise<BugTrackerIssuesViewModel> {
        return HttpService.Get<BugTrackerIssuesViewModel>(API_PATH + 'GetIssues', {
            status,
            priority
        });
    }

    public static async GetAllIssues(status?: BugTrackerStatus, priority?: BugTrackerPriority): Promise<BugTrackerIssuesViewModel> {
        return HttpService.Get<BugTrackerIssuesViewModel>(API_PATH + 'GetAllIssues', {
            status,
            priority
        });
    }

    public static async SearchIssues(onlyOpenIssues: boolean | null, onlyOwnIssues: boolean | null, assignedToSelf: boolean | null, term: string | null, categoryId: number | null, realmId: number | null, startDate: Date | null, endDate: Date | null, status: BugTrackerStatus | null, priority: BugTrackerPriority | null, page: number | null): Promise<BugTrackerIssuesViewModel> {
        return HttpService.Get<BugTrackerIssuesViewModel>(API_PATH + 'SearchIssues', {
            onlyOpenIssues,
            onlyOwnIssues,
            assignedToSelf,
            categoryId,
            realmId,
            term,
            startDate,
            endDate,
            status,
            priority,
            page
        });
    }

    public static async GetIssuesSummary(): Promise<BugTrackerIssueSummaryViewModel> {
        return HttpService.Get<BugTrackerIssueSummaryViewModel>(API_PATH + 'GetIssuesSummary');
    }

    public static async GetIssueDetails(id: number): Promise<BugTrackerIssueDetailsViewModel> {
        return HttpService.Get<BugTrackerIssueDetailsViewModel>(API_PATH + 'GetIssueDetails', {
            id
        });
    }

    public static async CreateCategory(request: CreateBugTrackerCategoryRequest): Promise<BugTrackerCategoryViewModel> {
        return HttpService.Post<BugTrackerCategoryViewModel>(API_PATH + 'CreateCategory', request);
    }

    public static async CreateIssue(request: CreateBugTrackerIssueRequest): Promise<BugTrackerIssueViewModel> {
        return HttpService.Post<BugTrackerIssueViewModel>(API_PATH + 'CreateIssue', request);
    }

    public static async UpdateIssue(request: UpdateBugTrackerIssueRequest): Promise<BugTrackerIssueDetailsViewModel> {
        return HttpService.Post<BugTrackerIssueDetailsViewModel>(API_PATH + 'UpdateIssue', request);
    }

    public static async RemoveIssue(id: number): Promise<boolean> {
        return HttpService.Post<boolean>(API_PATH + 'RemoveIssue', id);
    }

    public static async IssueReaction(request: BugTrackerIssueReactionRequest): Promise<boolean> {
        return HttpService.Post<boolean>(API_PATH + 'IssueReaction', request);
    }

    public static async AddComment(request: BugTrackerIssueAddCommentRequest): Promise<boolean> {
        return HttpService.Post<boolean>(API_PATH + 'AddComment', request);
    }

    public static async UpdateComment(request: BugTrackerIssueUpdateCommentRequest): Promise<boolean> {
        return HttpService.Post<boolean>(API_PATH + 'UpdateComment', request);
    }

    public static async RemoveComment(request: BugTrackerIssueRemoveCommentRequest): Promise<boolean> {
        return HttpService.Post<boolean>(API_PATH + 'RemoveComment', request);
    }
}
